import { TaskType } from "@common/types/task";
import { PersistableView, View } from "@common/types/views/views";
import {
    getTaskPreviewDefinition,
    PreviewTransaction,
} from "./taskCreationPreviewRegistry";

interface SelectionPreviewParams {
    taskType: TaskType;
    viewConfig?: PersistableView;
    transactions?: PreviewTransaction[];
    transactionsCount?: number;
}

export const hasTaskSelectionPreview = ({
    taskType,
    ...params
}: SelectionPreviewParams): boolean =>
    getTaskPreviewDefinition(taskType)?.hasSelectionPreview(params) ?? false;

export const doesSelectionViewOwnEntities = (taskType: TaskType): boolean =>
    getTaskPreviewDefinition(taskType)?.selectionViewOwnsEntities ?? false;

export const isEntityChangeHandledByPreview = (taskType: TaskType): boolean =>
    getTaskPreviewDefinition(taskType)?.isEntityChangeHandledByPreview ?? false;

export const hasTaskWorkspacePreview = ({
    taskType,
    hasContext,
}: {
    taskType: TaskType;
    hasContext: boolean;
}): boolean =>
    !!getTaskPreviewDefinition(taskType)?.hasWorkspacePreview && !hasContext;

export const getTransactionsPreviewFilters = ({
    filters,
    transactions,
}: {
    filters: PersistableView["filters"];
    transactions?: PreviewTransaction[];
}): PersistableView["filters"] => {
    if (!transactions?.length) {
        return filters;
    }
    return {
        entityIds: [
            ...new Set(
                transactions.map((transaction) => transaction.entity.id),
            ),
        ],
        transactionIds: transactions.map((transaction) => transaction.id),
    };
};

export const keepTaskSelectionOptions = ({
    previewOptions,
    taskOptions,
}: {
    previewOptions: View["options"];
    taskOptions: View["options"];
}): View["options"] => ({
    ...previewOptions,
    selection: taskOptions?.selection,
    bulkActions: taskOptions?.bulkActions,
    readonly: taskOptions?.readonly,
});
